import { Flex, Text } from '@chakra-ui/react';
import { LogoType } from 'src/features/MP/types';
import { useNavigate } from 'react-router-dom';
import { Icon } from 'src/components/atoms/Icon';

export const MerkatusLogo: React.FC<LogoType> = ({
  theme = 'white',
  clickable = true,
}) => {
  const navigate = useNavigate();
  return (
    <Flex
      align="center"
      cursor={clickable ? 'pointer' : 'default'}
      onClick={clickable ? () => navigate('/') : undefined}>
      <Text
        fontWeight="bold"
        fontSize="24px"
        lineHeight="1"
        color="text.lightGrey"
        mr={4}
        display="flex"
        alignItems="center">
        <Icon
          iconName="logo"
          boxSize={6}
          color={theme === 'dark' ? 'text.darkBlue.900' : 'text.lightGrey'}
        />
      </Text>

      <Text
        fontWeight="semibold"
        fontSize="24px"
        lineHeight="1"
        color={theme === 'dark' ? 'text.darkBlue.900' : 'text.lightGrey'}
        fontFamily="marketingPage">
        Merkatus.io
      </Text>
    </Flex>
  );
};
